"use strict";

define(['app'], function (app) {
  var productReviewsInAccordion = function productReviewsInAccordion() {

    var component = {};
    component.app = app;

    var largeProductDescription = document.querySelector(".athenaProductPage_breakpoint-lg_productDescription");
    var accordionHeaderLg = document.querySelector("#product-description-heading-lg-17");
    var accordionHeader = document.querySelector("#product-description-heading-17");

    // true = the dom has a review within the accordion.
    var _hasReviewAccordion = function _hasReviewAccordion() {
      if (accordionHeaderLg || accordionHeader) {
        return true;
      } else {
        return false;
      }
    };

    var _normalOrLgModeAccordion = function _normalOrLgModeAccordion() {
      // must only fire if a review is within the accordion.
      if (productReviewsInAccordion().hasReviewAccordion() === true) {
        // only fire if review accordion on page.
        if (window.getComputedStyle(largeProductDescription).display === "none") {
          return true;
        } else {
          return false;
        }
      }
    };

    // return if an element if a review accordion is or is not present , and if a ewview accordion is present, return a normal or large element within the arguments.
    var _hasReviewAccordionOrIsNormalWithLargeDetermination = function _hasReviewAccordionOrIsNormalWithLargeDetermination(accordionReviewNormalMode, accordionReviewLgMode, accordionNormalMode) {
      var element = void 0;
      if (productReviewsInAccordion().hasReviewAccordion() === true) {
        if (productReviewsInAccordion().normalOrLgModeAccordion() === true) {
          return element = accordionReviewNormalMode;
        } else {
          return element = accordionReviewLgMode;
        }
      } else {
        return element = accordionNormalMode;
      }
    };

    component.hasReviewAccordion = _hasReviewAccordion;
    component.normalOrLgModeAccordion = _normalOrLgModeAccordion;
    component.hasReviewAccordionOrIsNormalWithLargeDetermination = _hasReviewAccordionOrIsNormalWithLargeDetermination;

    return component;
  };

  return productReviewsInAccordion;
});
//# sourceMappingURL=productReviewsInAccordion.js.map
